import type { AllRouteEndpoints } from "../routeTypes";
export const appsUserInfoUpdateScheduledMergeDuplicateUsersRulesCacheKeys: AllRouteEndpoints[] = [
  "/apps/user_info/scheduled_merge_duplicate_users_rules",
];
